import React from 'react'
import { BarChart, Bar, XAxis, YAxis, LabelList, ResponsiveContainer, Legend } from 'recharts';
import BarBuilder from '../BarBuilder';
import {cleanHtml} from './AqUtilities';

export default function AqMatrix({question, data }) {
        
        const colors = ["#7AC36A","#89C1C1","#737373","#D4BB02","#F15A60"]

        var shapedData = question.rows.map(m=>{
                return {label:cleanHtml(m.text), values:data[m.value], total: Object.values(data[m.value]).reduce((accum, value) => accum + value, 0)};
        });

        const legendPayload=question.columns.map((m,index)=>{
            return {value:m.text, type:"rect", color:colors[index]};
         });
        
        legendPayload.push({value:`Total = ${shapedData[0].total}`, type:"circle", color:"#000000"});

        return (
            <div className="aq-matrix">
                <ResponsiveContainer  width="100%" height={(shapedData.length+1)*130}>
                <BarChart   data={shapedData} layout="vertical">
                    <Legend wrapperStyle={{top:0}} payload={legendPayload} layout="horizontal" verticalAlign="top"  />
                    <XAxis type="number" hide  axisLine={false}  padding={{ left: 20 }} domain={[0,shapedData[0].total]} />
                        <YAxis type="category" dataKey="label" dx={10} tickLine={false} axisLine={false} width={200} />
            
                    {BarBuilder({choices:question.columns,prefix:"values", colors})}

                </BarChart>
                </ResponsiveContainer>
            </div>
        )                
    }



